// general extension functions
module.exports = function () {
    //globals jwplayer
    window.jwplayer = require('_core_ext/lib/jwplayer');
    window.jwplayer.key = SitePreferences.JWPLAYER_KEY;
};
